import { FC } from 'react';
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Button,
} from '@chakra-ui/react';

export interface PlaylistDescriptionDialogProps {
  open: boolean;
  onClose: () => void;
  description?: string;
  title?: string;
}

export const PlaylistDescriptionDialog: FC<PlaylistDescriptionDialogProps> = ({
  open,
  onClose,
  description,
  title,
}) => (
  <Modal isOpen={open} onClose={onClose} data-testid="dialog" size="md">
    <ModalOverlay />
    <ModalContent>
      <ModalHeader data-testid="dialog-title" title={title}>
        {title}
      </ModalHeader>
      <ModalBody data-testid="dialog-content">
        <Text fontSize="md" wordBreak="break-word">
          {description}
        </Text>
      </ModalBody>
      <ModalFooter data-testid="dialog-actions">
        <Button onClick={onClose}>Done</Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);
